import type { TestimonialContent } from '../schema';

export const testimonials = [
  {
    id: 'testimonial.5CqD9y8j5XsJLrBtInNNvU',
    legacyId: '5CqD9y8j5XsJLrBtInNNvU',
    page: 'contact',
    title: 'Quick and Friendly Communication',
    quote:
      "The Sree Silks team is always just a message away. Whether it's about product details or shipping timelines, they make communication effortless. It's rare to find a brand that values its customers so much. Highly recommended!",
    rating: 4,
    name: 'Neha K',
    location: { city: 'Madurai', state: 'TN', country: 'IN' },
  },
  {
    id: 'testimonial.4CByE7XV1G42DnivpR1oNZ',
    legacyId: '4CByE7XV1G42DnivpR1oNZ',
    page: 'contact',
    title: 'Trustworthy and Reliable',
    quote:
      'I was initially hesitant to order online, but Sree Silks exceeded my expectations. Their team promptly answered my questions, shared saree images and fabric details, and ensured my order arrived in perfect condition. I now trust them completely for my ethnic wear needs!',
    rating: 5,
    name: 'Sowmya N',
    location: { city: 'LA', state: 'CA', country: 'US' },
  },
  {
    id: 'testimonial.5XitmiMpLIyaEF3M0CQwTU',
    legacyId: '5XitmiMpLIyaEF3M0CQwTU',
    page: 'contact',
    title: 'Personal Touch in Every Interaction',
    quote:
      'Sree Silks truly values its customers. I had a special request for packaging, and they customized it beautifully. The attention to detail and the personal touch in their service made my purchase feel so special!',
    rating: 5,
    name: 'Arunima P',
    location: { city: 'NYC', state: 'NY', country: 'US' },
  },
  {
    id: 'testimonial.1MjPHv4O8eqHYdAmlOOixt',
    legacyId: '1MjPHv4O8eqHYdAmlOOixt',
    page: 'contact',
    title: 'Seamless Ordering Experience',
    quote:
      'I reached out via WhatsApp to inquire about a specific saree design, and the team responded instantly! They helped me select the perfect saree, provided updates throughout the process, and ensured smooth delivery. Absolutely hassle-free!',
    rating: 5,
    name: 'Divya S',
    location: { city: 'Coimbatore', state: 'TN', country: 'IN' },
  },
  {
    id: 'testimonial.1w3RC3zvDmjssWvB1MThnW',
    legacyId: '1w3RC3zvDmjssWvB1MThnW',
    page: 'contact',
    title: 'Exceptional Customer Support',
    quote:
      'The team at Sree Silks is incredibly responsive and helpful. I had a few queries about customizing a wedding gift package, and they guided me through every detail with patience. Their customer service is as premium as their sarees!',
    rating: 5,
    name: 'Shanvika R',
    location: { city: 'Erode', state: 'TN', country: 'IN' },
  },
  {
    id: 'testimonial.z5n56s1KROZjnwxonzZKJ',
    legacyId: 'z5n56s1KROZjnwxonzZKJ',
    page: 'home',
    title: 'A Brand That Cares',
    quote:
      'From the moment I walked into their Jalakandapuram store, I felt their commitment to quality and tradition. The staff was incredibly knowledgeable, and the saree I chose for my wedding was a dream come true. Thank you, Sree Silks, for making my big day unforgettable!',
    rating: 5,
    name: 'Meera N',
    location: { city: 'Salem', state: 'TN', country: 'IN' },
  },
  {
    id: 'testimonial.55hpsHX7bcDA3lweWc19s6',
    legacyId: '55hpsHX7bcDA3lweWc19s6',
    page: 'home',
    title: 'Cultural Connection',
    quote:
      'Sree Silks has brought Elampillai artistry to a global platform. As someone living abroad, finding authentic and high-quality sarees has always been a challenge. Their online service made it easy, and the saree I received was a true embodiment of Indian craftsmanship.',
    rating: 5,
    name: 'Priya K',
    location: { city: 'Chicago', state: 'IL', country: 'USA' },
  },
  {
    id: 'testimonial.3mf9ekQfsk6RT3zsWuZA4C',
    legacyId: '3mf9ekQfsk6RT3zsWuZA4C',
    page: 'home',
    title: 'Seamless Customization',
    quote:
      "I ordered a saree bundle for my daughter's engagement, and the team at Sree Silks went above and beyond to customize it perfectly. From the color selection to the packaging, everything was flawless. Highly recommend for anyone looking for premium ethnic wear.",
    rating: 5,
    name: 'Revathi M',
    location: { city: 'Coimbatore', state: 'TN' },
  },
  {
    id: 'testimonial.1kqtmUR4hEz8ItxKcZBSFW',
    legacyId: '1kqtmUR4hEz8ItxKcZBSFW',
    page: 'home',
    title: 'Unmatched Elegance and Quality',
    quote:
      "I've never seen sarees with such exquisite detailing. Every piece feels like a masterpiece crafted with care. Sree Silks combines heritage with elegance, and their customer service is exceptional. They've gained a loyal customer in me!",
    rating: 4,
    name: 'Lakshmi S',
    location: { city: 'Bangalore', state: 'KA' },
  },
  {
    id: 'testimonial.hZLx1PTFZjatyCUqmZTvB',
    legacyId: 'hZLx1PTFZjatyCUqmZTvB',
    page: 'home',
    title: 'Wedding Gifting Excellence',
    quote:
      "Sree Silks made my sister's wedding truly special. Their customizable gifting solutions were a hit with our family, and the sarees were absolutely stunning. The intricate patterns and luxurious feel captured the essence of our traditions perfectly!",
    rating: 5,
    name: 'Aarthi R',
    location: { city: 'Chennai', state: 'TN' },
  },
  {
    id: 'testimonial.4wzD4uasPaY6dNNQ3d1uUb',
    legacyId: '4wzD4uasPaY6dNNQ3d1uUb',
    page: 'home',
    quote: 'Wonderful designs',
    rating: 5,
    name: 'Malli',
    location: { city: 'Salem', state: 'TN' },
  },
] satisfies readonly TestimonialContent[];
